import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { validationmethod } from "../../../shared/common/validationmethod";
import { LocalStorageSettingsService } from "../../../shared/services/local-storage-settings.service";
import { ErrorMessages } from "../../../shared/common/errormessages";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonService } from "../../../shared/services/common.service";
import { EtlService } from "../../vault-data-migration-etl/etl.service";
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
// import { ActionwithcheckboxComponent } from 'src/app/shared/common/Actionwithcheckbox';

/**
  * Modified by Ashwin M
  * 05/09/2025
  * code modified to include current migration record into re Initiate Data
  */
export interface FormData {
  reInitateType: '',
  migrationId: 0,
  setId: 0,
  migrationTraceId: 0
  migrationCurrent: null
}

@Component({
    selector: 'app-re-initiate-popup',
    templateUrl: './re-initiate-popup.component.html',
    styleUrls: ['./re-initiate-popup.component.scss'],
    standalone: false
})
export class ReInitiatePopupComponent implements OnInit {
  backgroundColorButton = '';
  formValid
  reInitateType = ''
  header
  btnName
  selectedReInitateOrReMigrate: any;
  extractionType;

  // added variable for holding the dynamic values to show in the pop for extractiona & load
  option1;
  option2;
  headertype;
  mappedAttributesColumnDefs;
  MappingAttributecheckbox: number[] = [];
  buttonIdList = [];
  migrationtraceid;
  directdataapiextraction = false;


  /**
    * Modified by Ashwin M
    * 05/09/2025
    * code modified to include current migration record into re Initiate Data
    */
  reInitiateData = {
    setId: 0,
    migrationId: 0,
    activity: "",
    reExtractionType: "",
    migrationTraceId: 0,
    migrationCurrent: null

  }
  isfullFilledOptDisabled: any = true;
  mappingConfigurationData: any = [];
  mappedAttributesGrid
  selectedObjects: number[] = [];
  lastpage: any;
  currentpage: any;
  nextpage: any;
  nextpageplusone: any;
  totalpages: any;
  pagesize: any;
  mappingObjectIds: number[] = [];
  // mappedAttributesGrid: any;
  selectedMappedAttributes: any[] = [];
  paginationNumberFormatter;
  defaultColDef;
  paginationPageSize;
  rowClassRules;
  components;
  mappedAttributesRowData: any[] = [];
  selectedMappingObjectIds: number[] = [];
  allSets: any[] = [];
  filteredSets: any[] = [];
  migrationParentId;

  selectedSets: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: FormData, public dialogref: MatDialogRef<ReInitiatePopupComponent>, private Service: ReportingServiceService,
    private validation: validationmethod, private localStorageSettings: LocalStorageSettingsService, private snackbar: MatSnackBar,
    private errorMssg: ErrorMessages, private spinner: NgxUiLoaderService, private snackBar: MatSnackBar, private commonService: CommonService, private service: EtlService) {

  }

  ngOnInit(): void {
    // initial values set to extraction
    this.option1 = "Full";
    this.option2 = "Failed";
    this.headertype = "Extraction"
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    console.log(this.data)
    this.reInitiateData.migrationId = this.data.migrationId;
    this.reInitiateData.setId = this.data.setId;
    this.reInitateType = this.data.reInitateType;
    this.reInitiateData.migrationTraceId = this.data.migrationTraceId;/**
    * Modified by Ashwin M
    * 05/09/2025
    * code modified to get current migration record into re Initiate Data from broadcaseted data
    */

    this.reInitiateData.migrationCurrent = this.data.migrationCurrent;
    console.log(this.data.migrationCurrent)
    this.migrationtraceid = this.data.migrationTraceId;
    if (this.reInitateType === 'rm') {
      this.header = 'Add Sets For Migration'
      this.btnName = 'Re-Migrate'
      this.retrieveSourceTargetObjects();
      this.migrationParentId = this.data.migrationId;
      this.loadSets();
    }
    else if (this.reInitateType == 'gm') {
      this.header = 'Re-Extract'
      this.btnName = 'Re-Initiate'
    } else {
      this.header = 'Re-Migration'
      this.btnName = 'Re-Initiate'

    }

    this.commonService.getMigrationType(this.reInitiateData.migrationId).subscribe((response) => {
      console.log(response);
      if (response == 'Vault Safety Data Ingestion') {
        this.directdataapiextraction = true;
      }


    })


    this.mappedAttributesColumnDefs = [{
      headerName: '',
      field: 'select',
      width: 70,
      pinned: 'left',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      suppressMenu: true,
      sortable: false,
      filter: false
    },
    { headerName: 'Source Object', headerTooltip: 'Source Object', tooltipValueGetter: (params) => 'Source Object : ' + params.value, field: 'source_object', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Target Object', headerTooltip: 'Target Object', tooltipValueGetter: (params) => 'Target Object : ' + params.value, field: 'target_object', filter: 'agTextColumnFilter', width: 250 },
    { headerName: 'Target Attribute', headerTooltip: 'Target Attribute', tooltipValueGetter: (params) => 'Target Attribute : ' + params.value, field: 'target_attribute', filter: 'agTextColumnFilter', width: 250 }
    ]

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

  }


  selectedAttributeIds: number[] = [];
  selectedAttributeRows: any[] = [];

  onSelectionChanged(event: any) {
    if (!this.mappedAttributesGrid) {
      return;
    }

    this.selectedAttributeRows = this.mappedAttributesGrid.getSelectedRows();

    this.selectedAttributeIds = this.selectedAttributeRows
      .map(row => row.mappingAttributesId)
      .filter(id => id != null);

    console.log('Selected attribute rows:', this.selectedAttributeRows);
    console.log('Selected attribute IDs:', this.selectedAttributeIds);
  }

  onMappedAttributesGridReady(params: any) {
    this.mappedAttributesGrid = params.api;
    this.mappedAttributesGrid.setPagination(true);
    this.mappedAttributesGrid.setGridOption('paginationPageSize', this.paginationPageSize);
    this.mappedAttributesGrid.setGridOption('rowData', []);
  }


  onMappedObjectChange(event: any) {

    console.log('Raw selectionChange event:', event);

    const value = event?.value;

    if (!Array.isArray(value)) {
      console.error('selectionChange value is invalid:', value);
      return;
    }

    this.selectedMappingObjectIds = value;

    console.log('Selected mapping object IDs:', this.selectedMappingObjectIds);

    if (this.selectedMappingObjectIds.length === 0) {
      this.mappedAttributesGrid?.setGridOption('rowData', []);
      return;
    }

    this.loadMappedAttributes();
  }


  loadMappedAttributes() {

    if (!this.selectedMappingObjectIds || this.selectedMappingObjectIds.length === 0) {
      console.warn('No mapping object IDs selected');
      this.mappedAttributesGrid?.setGridOption('rowData', []);
      return;
    }

    console.log('Calling API with IDs:', this.selectedMappingObjectIds);

    this.spinner.start();

    this.commonService
      .retrieveMappedAttributes(this.selectedMappingObjectIds)
      .subscribe({
        next: (res) => {
          console.log('Mapped attributes response:', res);

          this.mappedAttributesRowData = res || [];
          this.mappedAttributesGrid.setGridOption('rowData', this.mappedAttributesRowData);

          this.mappedAttributesGrid.paginationGoToFirstPage();
          this.onPaginationChanged();

          this.spinner.stop();
        },
        error: (err) => {
          console.error('Error loading mapped attributes', err);
          this.mappedAttributesGrid.setGridOption('rowData', []);
          this.spinner.stop();
        }
      });
  }

  onPaginationChanged() {
    if (this.mappedAttributesGrid) {
      this.lastpage = this.mappedAttributesGrid.paginationIsLastPageFound();
      this.currentpage = this.mappedAttributesGrid.paginationGetCurrentPage() + 1
      this.nextpage = this.mappedAttributesGrid.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.mappedAttributesGrid.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.mappedAttributesGrid.paginationGetTotalPages()
    }
  }

  reInitiate() {
    this.reInitiateData.activity = this.selectedReInitateOrReMigrate;
    this.reInitiateData.reExtractionType = this.extractionType
    if (this.selectedReInitateOrReMigrate == null || this.selectedReInitateOrReMigrate == undefined || this.selectedReInitateOrReMigrate == '') {
      this.validation.getvalidationmessage();

    } else {

      if (this.selectedReInitateOrReMigrate == 'Extraction' && this.reInitateType === 'cd') {
        if (this.extractionType == null || this.extractionType == undefined || this.extractionType == '') {
          this.validation.getvalidationmessage();
        } else {

          console.log(this.reInitiateData)
          this.reInitiateService()

        }
      }
      else if (this.extractionType == 'GlobalExtraction' && this.reInitateType == 'gm') {
        this.reInitiateService();
      }
      else if (this.selectedReInitateOrReMigrate == 'Load' && this.reInitateType == 'cd') {
        /**
         * @modified by Sai Naveen Somaraju
         * @Date 25/08/2023
         * if the reinitiate type is incremental then we have seperate service.
         * if it load --> currently this option is not implemented
         * Modified by Ashwin M
         * 05/09/2025
         * code modified to call reInitiate when lauching for virtualisation
         */
        if (this.extractionType == "Incremental") {
          this.reInitiateForIncrementalLoad()
        }
        else if (this.extractionType == "Full") {
          this.snackBar.open("Full Load is not supported.", "Ok", { duration: 5000 })
        } else {
          this.reInitiateService()
        }
      }
      else {
        console.log(this.reInitiateData)
        if (this.reInitateType === 'rm') {

          this.reMigrateService()
        }
        else {
          this.reInitiateService()
        }

      }

    }
  }

  close() {
    this.dialogref.close();

  }

  action(value: any) {
    this.selectedReInitateOrReMigrate = value;
    if (value == 'Extraction') {
      // it will display same in the re-initiate pop extraction options
      this.headertype = "Extraction"
      this.option1 = "Full"
      this.option2 = "Failed"
      this.isfullFilledOptDisabled = false;
    }
    else if (value == "Load") {
      /**
        * Modified by Ashwin M
        * 05/09/2025
        * code modified to allow re initiate load for migration type -> Data Virtualisation
        */
      this.spinner.start();
      // it will display same in the re-initiate pop load options
      if (this.reInitiateData.migrationCurrent.migrationType.includes("Data Virtualization")){
        this.isfullFilledOptDisabled = true;
      } else {
        this.headertype = "Load"
        this.option1 = "Full";
        this.option2 = "Incremental"
        this.isfullFilledOptDisabled = false;
      }
      this.spinner.stopAll();

    }
    else {
      this.isfullFilledOptDisabled = true;

    }

  }

  fullfillAction(value: any) {
    this.extractionType = value

  }
  reInitiateService() {
    this.spinner.start()

    this.service.reInitiateMigration(this.reInitiateData).subscribe(response => {
      console.log(response)
      if (response['error'] == true) {

        this.spinner.stop();

        this.snackBar.open(response['statusMessage'], "OK", { duration: 5000 });

      } else {
        this.spinner.stop();
        this.dialogref.close()
        this.snackBar.open(response['statusMessage'], "OK", { duration: 5000 });

      }

    });
  }

  globalAction(value: any) {
    this.selectedReInitateOrReMigrate = 'GlobalExtraction';
  }

  /**
   * @Added by Ravi G
   * @Date: 23/11/2022
   * @Desc re-migrate from extraction means->user needs to perform ETLV from starting, source files need to be extracted newly and transformed and loaded to vault
   * re-migrate from transformation means->user needs to perform TLV , source files need not to be extracted newly, migration will start from transformation and loaded to vault
   **/
  reMigrateService() {

    if (!this.selectedAttributeIds.length) {
      this.snackBar.open(
        'Please select at least one Attribute', 'OK', { duration: 3000 });
      return;
    }

    this.spinner.start()

    let completed = 0;
    this.selectedSets.forEach((setId) => {

      this.service
        .reMigrate(this.reInitiateData.migrationId, setId, this.reInitiateData.activity
        ).subscribe({
          next: (response) => {
            completed++;

            if (!response?.error) {

              const setIdVersion = response.data;

              if (!setIdVersion) {
                console.error('setIdVersion missing in response');
                return;
              }
              const payload = {
                tenantid: this.localStorageSettings.getSettings('dnsName'),
                migrationid: this.reInitiateData.migrationId,
                setid: setIdVersion,
                attributeids: this.selectedAttributeIds.join(',')

              };

               /**
               * @Added by Renuka
               * @Date: 23/12/2025
               * @Desc added this api to save remigrate data to the remigratemappingandobject table for patch.
               * **/
              this.commonService.saveRemigrateMappingAndObjects(payload).subscribe();
              this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
            }

            if (completed === this.selectedSets.length) {
              this.spinner.stop();
              this.dialogref.close();
              this.snackBar.open(response['statusMessage'], "OK", { duration: 5000 });
            }
            console.log(response);
          },
          error: () => {
            completed++;
            if (completed === this.selectedSets.length) {
              this.spinner.stop();
            }
          }
        });

    });

  }
  /**
   * @author SaiNaveen Somaraju
   * @Date : 18/08/2023
   * This method will call the incrementalLoad api
   */
  reInitiateForIncrementalLoad() {
    this.spinner.start()

    this.service.reInitiateMigrationForIncrementalLoad(this.reInitiateData).subscribe(response => {
      console.log(response)
      if (response['error'] == true) {

        this.spinner.stop();

        this.snackBar.open(response['statusMessage'], "OK", { duration: 5000 });

      } else {
        this.spinner.stop();
        this.dialogref.close()
        this.snackBar.open(response['statusMessage'], "OK", { duration: 5000 });

      }

    });
  }


 /**
   * Modified by Renuka
   * @Date: 23/12/2025
   * @Desc Added to Retrieve mapped objects and sets**/
  retrieveSourceTargetObjects() {
    if (this.mappingConfigurationData.length > 0) {
      return;
    }
    this.spinner.start();

    this.commonService.retrieveSourceTargetObjects().subscribe({
      next: (res: any[]) => {
        this.mappingConfigurationData = res || [];
        this.spinner.stop();
      },
      error: (err) => {
        console.error('Error fetching source-target objects', err);
        this.spinner.stop();
      }
    });
  }


  setSearchText: string = '';
  filteredSetsForDropdown: any[] = [];

  onSetDropdownOpen() {
    if (!this.filteredSets || this.filteredSets.length === 0) {
    this.snackBar.open('No load completed sets available','OK',{ duration: 5000 });
  }
    this.filteredSetsForDropdown = [...this.filteredSets];
  }

  filterSets() {
    const search = this.setSearchText?.toLowerCase() || '';

    this.filteredSetsForDropdown = this.filteredSets.filter(set =>
      set.setid.toString().toLowerCase().includes(search)
    );
  }



  loadSets() {
    this.spinner.start();

    this.commonService.retrieveCompletedLoadsets().subscribe({
      next: (res: any[]) => {
        this.allSets = res || [];

        this.filteredSets = this.allSets.filter(
          s => Number(s.migrationid) === Number(this.migrationParentId)
        );
        console.log(this.migrationParentId)
        this.filteredSetsForDropdown = [...this.filteredSets];
        this.spinner.stop();
      },
      error: err => {
        console.error('Error loading sets', err);
        this.spinner.stop();
      }
    });
  }

}
